import CiPeriod from '@/generated/classes/CiPeriod';
export default class CiPeriodExtend  extends CiPeriod {
  constructor() {
    super();
  }
}
